/**
 * The Settings route subtree, defined once.
 *
 * Exported as a route object rather than written inline in `app/routes.tsx`
 * because the tests mount it too: a test that rebuilds the category routes by
 * hand is a test that can pass while the real ones are wrong, which is exactly
 * the failure the two-pane navigation invites.
 */

import { Navigate, type RouteObject } from "react-router-dom";
import { AccountPanel } from "./AccountPanel";
import { AppearancePanel } from "./AppearancePanel";
import { CapturePanel } from "./CapturePanel";
import { DEFAULT_SETTINGS_CATEGORY } from "./categories";
import { NotificationsPanel } from "./NotificationsPanel";
import { PrivacyPanel } from "./PrivacyPanel";
import { SettingsShell } from "./SettingsShell";
import { ViewerPanel } from "./ViewerPanel";

export const settingsChildren: RouteObject[] = [
  { index: true, element: <Navigate to={DEFAULT_SETTINGS_CATEGORY} replace /> },
  { path: "hesap", element: <AccountPanel /> },
  { path: "gorunum", element: <AppearancePanel /> },
  { path: "cekim", element: <CapturePanel /> },
  { path: "bildirimler", element: <NotificationsPanel /> },
  { path: "goruntuleyici", element: <ViewerPanel /> },
  { path: "gizlilik", element: <PrivacyPanel /> },
  // An unknown category is a typo, not a missing page. Named absolutely
  // rather than as ".", which inside a splat route resolves to the bad URL
  // itself and redirects nowhere.
  {
    path: "*",
    element: <Navigate to={`/ayarlar/${DEFAULT_SETTINGS_CATEGORY}`} replace />,
  },
];

export const settingsRoute: RouteObject = {
  // Two panes, and the selected one is in the URL: a link to
  // /ayarlar/gizlilik opens on Privacy, Back leaves a category rather than
  // leaving Settings, and a reload stays where the reader was.
  path: "ayarlar",
  element: <SettingsShell />,
  children: settingsChildren,
};
